import { render, staticRenderFns } from "./editorBoxOne.vue?vue&type=template&id=73a6ca0e&scoped=true&"
import script from "./editorBoxOne.vue?vue&type=script&lang=js&"
export * from "./editorBoxOne.vue?vue&type=script&lang=js&"
import style0 from "./editorBoxOne.vue?vue&type=style&index=0&id=73a6ca0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6ca0e",
  null
  
)

export default component.exports